var map = {
	"./assets/image/sgtest/result/kurisu/role_sad.png": "8970",
	"./assets/image/sgtest/result/mayuri/role_sad.png": "e2a0",
	"./assets/image/sgtest/result/rintarou/role_sad.png": "0329",
	"./assets/image/sgtest/result/suzuha/role_sad.png": "1456"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31d6";